import React from 'react';
import { Facebook, Instagram, Mail, Phone, MapPin } from 'lucide-react';
export function FreeTrialFooter() {
  return <footer className="bg-black text-white pt-16 pb-8 border-t border-gray-900" data-id="element-885">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-886">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12" data-id="element-887">
          <div data-id="element-888">
            <div className="flex items-center gap-3 mb-6" data-id="element-889">
              <div className="relative w-10 h-10 overflow-hidden rounded-full border border-[#00D4FF] bg-black" data-id="element-890">
                <img src="https://cdn.magicpatterns.com/uploads/fmBXjQm2BPtC5bTSRKvwCz/walkerlogo-gigapixel-cgi-3600w.png" alt="Walker's Martial Arts Logo" className="w-full h-full object-cover" data-id="element-891" />
              </div>
              <div className="flex flex-col" data-id="element-892">
                <span className="text-white font-bold text-base leading-none tracking-wide uppercase" data-id="element-893">
                  Walker's
                </span>
                <span className="text-[#00D4FF] font-bold text-xs leading-none tracking-wider uppercase" data-id="element-894">
                  Martial Arts
                </span>
              </div>
            </div>
            <p className="text-gray-400 mb-6 max-w-xs" data-id="element-895">
              "Where Families Kick Together"
              <br data-id="element-896" />
              Proudly serving the Bloomington community and surrounding area
              since 1999.
            </p>
            <div className="flex gap-4" data-id="element-897">
              <a href="#" className="w-10 h-10 rounded-full bg-gray-900 flex items-center justify-center text-gray-400 hover:bg-[#00D4FF] hover:text-black transition-all" data-id="element-898">
                <Facebook size={20} data-id="element-899" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-gray-900 flex items-center justify-center text-gray-400 hover:bg-[#00D4FF] hover:text-black transition-all" data-id="element-900">
                <Instagram size={20} data-id="element-901" />
              </a>
            </div>
          </div>
          <div data-id="element-902">
            <h4 className="text-lg font-bold text-white mb-6 uppercase tracking-wider" data-id="element-903">
              Contact Us
            </h4>
            <ul className="space-y-4 text-gray-400" data-id="element-904">
              <li className="flex items-start gap-3" data-id="element-905">
                <MapPin className="w-5 h-5 text-[#00D4FF] shrink-0 mt-1" data-id="element-906" />
                <span className="text-sm" data-id="element-907">
                  1304 E. Empire Suite 2.
                  <br data-id="element-908" />
                  Bloomington, Illinois 61701
                  <br data-id="element-909" />
                  <span className="text-xs text-gray-500" data-id="element-910">
                    (Inside the Regions Bank Complex at the intersection of
                    Empire & Towanda)
                  </span>
                </span>
              </li>
              <li className="flex items-center gap-3" data-id="element-911">
                <Phone className="w-5 h-5 text-[#00D4FF] shrink-0" data-id="element-912" />
                <a href="tel:3092422440" className="hover:text-white transition-colors" data-id="element-913">
                  (309) 242-2440
                </a>
              </li>
              <li className="flex items-center gap-3" data-id="element-914">
                <Mail className="w-5 h-5 text-[#00D4FF] shrink-0" data-id="element-915" />
                <a href="mailto:walkerskicks@gmail.com" className="hover:text-white transition-colors" data-id="element-916">
                  walkerskicks@gmail.com
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-917">
            <h4 className="text-lg font-bold text-white mb-6 uppercase tracking-wider" data-id="element-918">
              Class Hours
            </h4>
            <ul className="space-y-2 text-gray-400" data-id="element-919">
              <li className="flex justify-between" data-id="element-920">
                <span data-id="element-921">Monday - Thursday</span>
                <span className="text-white" data-id="element-922">5:00 AM - 9:00 PM</span>
              </li>
              <li className="flex justify-between" data-id="element-923">
                <span data-id="element-924">Friday</span>
                <span className="text-white" data-id="element-925">5:00 AM - 7:00 PM</span>
              </li>
              <li className="flex justify-between" data-id="element-926">
                <span data-id="element-927">Saturday</span>
                <span className="text-white" data-id="element-928">9:00 AM - 2:00 PM</span>
              </li>
              <li className="flex justify-between" data-id="element-929">
                <span data-id="element-930">Sunday</span>
                <span className="text-white" data-id="element-931">8:00 AM - 12:00 PM</span>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-gray-900 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-500" data-id="element-932">
          <p data-id="element-933">
            &copy; {new Date().getFullYear()} Walker's Martial Arts. All rights
            reserved.
          </p>
          <div className="flex gap-6" data-id="element-934">
            <a href="#" className="hover:text-white transition-colors" data-id="element-935">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-936">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}